import { MainScreen } from '@/components/shared/MainScreen/MainScreen';
import { Card, CardContent, Spinner } from '@/components/ui';
import { useProjectViews } from '@/hooks/useProjectViews';
import { useAuthStore } from '@/stores/authStore';
import { PaymentsComponent } from './components/PaymentsComponent';

export default function PaymentsPage() {
  const projects = useProjectViews();
  const account = useAuthStore((state) => state.session?.accountId);
  return (
    <MainScreen
      headerContent={<h1>Payments</h1>}
      contentClassName="pageContent text-left"
    >
      {projects.isPending ? (
        <div role="status" className="flex items-center justify-center py-24">
          <div className="flex flex-col items-center gap-4">
            <Spinner size="lg" />
            <p className="text-[var(--text-dark-secondary,rgba(255,255,255,0.7))]">
              Loading project payments…
            </p>
          </div>
        </div>
      ) : projects.isError ? (
        <Card role="alert" className="mx-auto mt-6 max-w-2xl">
          <CardContent className="p-8 text-center">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-500/15">
              <i
                className="ri-error-warning-line text-2xl text-red-400"
                aria-hidden="true"
              />
            </div>
            <h2 className="mb-2 text-xl font-semibold text-[var(--text-dark-primary,#f5f5f5)]">
              Failed to load payments
            </h2>
            <p className="mb-4 text-[var(--text-dark-secondary,rgba(255,255,255,0.7))]">
              {projects.error.message}
            </p>
            <button
              type="button"
              aria-label="Retry project payments"
              onClick={() => void projects.refetch()}
              className="rounded-lg bg-[var(--state-brand-active,#36d399)] px-4 py-2 font-medium text-[var(--text-light-primary,#141414)] transition-all hover:brightness-110 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[--state-brand-active]"
            >
              Retry
            </button>
          </CardContent>
        </Card>
      ) : (
        <PaymentsComponent projects={projects.data} account={account ?? ''} />
      )}
    </MainScreen>
  );
}
